import { X, User, Calendar, Tag, FileText } from 'lucide-react';
import { Modal } from 'react-bootstrap';

interface LogDetailsModalProps {
  data: any;
  onClose: () => void;
}

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const isoString = date.toISOString();
  const year = isoString.substring(0, 4);
  const month = isoString.substring(5, 7);
  const day = isoString.substring(8, 10);
  const hour = isoString.substring(11, 13);
  const minute = isoString.substring(14, 16);
  const second = isoString.substring(17, 19);
  return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
};

const LogDetailsModal: React.FC<LogDetailsModalProps> = ({ data, onClose }) => {
  if (!data) return null;

  const renderJsonData = (jsonData: any) => {
    if (!jsonData) return null;

    return (
      <pre className="bg-light p-4 rounded" style={{ maxHeight: '400px', overflow: 'auto' }}>
        <code>{JSON.stringify(jsonData, null, 2)}</code>
      </pre>
    );
  };

  return (
    <>
      <Modal.Header className="border-0 pb-0">
        <Modal.Title className="w-100">
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="fw-bold mb-0">Detalhes do Log</h2>
            <button
              className="btn btn-sm btn-icon btn-active-color-primary"
              onClick={onClose}
            >
              <X size={24} />
            </button>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-4">
        <div className="d-flex flex-column gap-4">
          <div className="card bg-light-primary border-0">
            <div className="card-body p-4">
              <div className="d-flex align-items-start gap-3">
                <div
                  className="d-flex align-items-center justify-content-center bg-primary"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    minWidth: '40px',
                  }}
                >
                  <User size={20} className="text-white" />
                </div>
                <div className="flex-grow-1">
                  <div className="text-gray-600 fs-7 fw-semibold mb-1">Usuário</div>
                  <div className="text-gray-900 fs-5 fw-bold">{data.user}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-4">
            <div className="col-md-6">
              <div className="card border border-gray-300">
                <div className="card-body p-4">
                  <div className="d-flex align-items-start gap-3">
                    <div
                      className="d-flex align-items-center justify-content-center bg-light-info"
                      style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '6px',
                        minWidth: '36px',
                      }}
                    >
                      <Tag size={18} className="text-info" />
                    </div>
                    <div>
                      <div className="text-gray-600 fs-7 fw-semibold mb-1">Tipo</div>
                      <div className="text-gray-900 fs-6 fw-semibold">{data.type}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card border border-gray-300">
                <div className="card-body p-4">
                  <div className="d-flex align-items-start gap-3">
                    <div
                      className="d-flex align-items-center justify-content-center bg-light-success"
                      style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '6px',
                        minWidth: '36px',
                      }}
                    >
                      <Calendar size={18} className="text-success" />
                    </div>
                    <div>
                      <div className="text-gray-600 fs-7 fw-semibold mb-1">Data/Hora</div>
                      <div className="text-gray-900 fs-6 fw-semibold">
                        {formatDate(data.created_at)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card border border-gray-300">
            <div className="card-body p-4">
              <div className="d-flex align-items-start gap-3 mb-3">
                <div
                  className="d-flex align-items-center justify-content-center bg-light-warning"
                  style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '6px',
                    minWidth: '36px',
                  }}
                >
                  <FileText size={18} className="text-warning" />
                </div>
                <div>
                  <div className="text-gray-600 fs-7 fw-semibold mb-1">Descrição</div>
                  <div className="text-gray-900 fs-6">{data.name}</div>
                </div>
              </div>
            </div>
          </div>

          {data.json && Object.keys(data.json).length > 0 && (
            <div className="card border border-gray-300">
              <div className="card-body p-4">
                <h5 className="fw-bold mb-4">Dados do Log</h5>
                {renderJsonData(data.json)}
              </div>
            </div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0">
        <button className="btn btn-light" onClick={onClose}>
          Fechar
        </button>
      </Modal.Footer>
    </>
  );
};

export default LogDetailsModal;
